module.exports = new __parcel__URL__("Brainstorming.f240c002.svg").toString();